import React from "react";
import classNames from "classnames/bind";
import styles from "./Inquiry.module.scss";
import Pagination from "../commons/Pagination/Pagination";
import dayjs from "dayjs";

const cx = classNames.bind(styles);

export default function Inquiry({
  currentPage,
  lastPage,
  perPage,
  total,
  data,
  options,
  handlePage,
  handleOptions,
  handleDelete,
  handleDetailMove,
}) {
  return (
    <>
      <div className={cx("option_container")}>
        <div className={cx("option_inner")}>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>구분</p>
            </div>
            <div className={cx("option_button_box")}>
              <button
                className={cx("option_button", {
                  active: options.locale === "",
                })}
                onClick={() => handleOptions("locale", "")}
              >
                전체
              </button>
              <button
                className={cx("option_button", {
                  active: options.locale === "ko",
                })}
                onClick={() => handleOptions("locale", "ko")}
              >
                한국어
              </button>
              <button
                className={cx("option_button", {
                  active: options.locale === "en",
                })}
                onClick={() => handleOptions("locale", "en")}
              >
                영문
              </button>
            </div>
          </div>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>정렬</p>
            </div>
            <div className={cx("option_button_box")}>
              <button
                className={cx("option_button", {
                  active: options.sort === "desc",
                })}
                onClick={() => handleOptions("sort", "desc")}
              >
                최신순
              </button>
              <button
                className={cx("option_button", {
                  active: options.sort === "asc",
                })}
                onClick={() => handleOptions("sort", "asc")}
              >
                오래된순
              </button>
            </div>
          </div>
        </div>
        <div className={cx("option_inner")}>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>다운로드 유무</p>
            </div>
            <div className={cx("option_button_box")}>
              <button
                className={cx("option_button", {
                  active: options.hasDocument === "",
                })}
                onClick={() => handleOptions("hasDocument", "")}
              >
                전체
              </button>
              <button
                className={cx("option_button", {
                  active: options.hasDocument === true,
                })}
                onClick={() => handleOptions("hasDocument", true)}
              >
                유
              </button>
              <button
                className={cx("option_button", {
                  active: options.hasDocument === false,
                })}
                onClick={() => handleOptions("hasDocument", false)}
              >
                무
              </button>
            </div>
          </div>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>검색어</p>
            </div>
            <div className={cx("option_button_box")}>
              <input
                type="text"
                className={cx("input")}
                value={options?.search}
                name="search"
                onChange={(e) => handleOptions("search", e.target.value)}
                placeholder="회사명, 이름, 이메일, 전화번호를 입력해 주세요."
              />
            </div>
          </div>
        </div>
      </div>
      <div className={cx("table_container")}>
        <table className={cx("table")}>
          <thead>
            <tr>
              <th className={cx("th")}>번호</th>
              <th className={cx("th")}>구분</th>
              <th className={cx("th")}>회사명</th>
              <th className={cx("th")}>이름</th>
              <th className={cx("th")}>이메일</th>
              <th className={cx("th")}>전화번호</th>
              <th className={cx("th")}>문의 내용</th>
              <th className={cx("th")}>다운로드</th>
              <th className={cx("th")}>작성일</th>
              <th className={cx("th")}>관리</th>
            </tr>
          </thead>
          <tbody>
            {data[currentPage]?.map((el) => (
              <tr key={el.id}>
                <td className={cx("td")}>{el.id}</td>
                <td className={cx("td")}>
                  {el?.locale === "ko" ? "한국어" : "영문"}
                </td>
                <td className={cx("td")}>{el?.company || "-"}</td>
                <td className={cx("td")}>{el?.name || "-"}</td>
                <td className={cx("td")}>{el?.email || "-"}</td>
                <td className={cx("td")}>{el?.phone || "-"}</td>
                <td className={cx("td")}>{el?.request_reason || "-"}</td>
                <td className={cx("td")}>{el?.hasDocument ? "유" : "무"}</td>
                <td className={cx("td")}>
                  {dayjs(el?.created_at).format("YYYY.MM.DD")}
                </td>
                <td className={cx("td")}>
                  <button
                    onClick={() => handleDetailMove(el?.id)}
                    className={cx("table_button")}
                  >
                    상세보기
                  </button>
                  <button
                    onClick={() => handleDelete(el?.id)}
                    className={cx("table_button")}
                  >
                    삭제
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {total && total !== 0 ? (
        <Pagination
          currentPage={currentPage}
          lastPage={lastPage}
          perPage={perPage}
          handlePage={handlePage}
        />
      ) : (
        <div className={cx("empty_box")}>
          <p className={cx("empty_text")}>등록 된 문의가 없습니다.</p>
        </div>
      )}
      <div className={cx("input_box")}>
        <a
          href="https://kcmonomer.jandi.com/app/#!/room/34634928"
          target="_blank"
          rel="noopener noreferrer"
          className={cx("text", "link")}
        >
          잔디 이동 하기
        </a>
      </div>
    </>
  );
}
